import React, { useState, useEffect, useRef } from 'react'
import { FormControl, Table, Button, OverlayTrigger } from 'react-bootstrap';
import { FetchInventoryReport, FetchRegisterInventoryReport, FetchBillClearance } from '../../fetcher';
import AlertMessage from '../presentational-components/AlertMessage';
import { useSingleDateFilter, useDateFilter, useSearchFilter, useSelectFilter, useFilterReport, DateSelect } from '../presentational-components/filterutils';
import LoadingSpinner from '../presentational-components/LoadingSpinner';
import { useSortSalesReport } from '../presentational-components/tablehooks';
import moment from 'moment'
import 'moment/locale/de'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { ExportCSV } from '../presentational-components/ExportCSV';
import DescriptionTooltip from '../presentational-components/DescriptionTooltip';
import { SimpleDateSelect } from '../presentational-components/FilterComponents'

moment.locale('de')

const InventoryReport = () => {

    const [filterable, setFilterable] = useState(false)
    const [filteredReports, setFilteredReports] = useState([])
    const [sortedReports, setSortedReports] = useState([])
    const [salesReport, setSalesReport] = useState([])
    const [lastSelected, setLastSelected] = useState("")
    const [options, setOptions] = useState([])

    const { sortSalesReport } = useSortSalesReport(salesReport, setSortedReports)
    const { filterReportBySearchInput, filterReportByDateInput, filterReportBySelectInput } = useFilterReport()
    const { dateSelect, handleDatePickerCallback, handleClearFilter } = useDateFilter()
    const { singleDateSelect, handleSingleDatePickerCallback, handleClearFilter1 } = useSingleDateFilter()

    const [statusSelect, handleStatusSelectChange] = useSelectFilter()
    const { searchInput, handleSearchInput } = useSearchFilter()

    const [boutiqueSelection, setBoutiqueSelection] = useState("")
    const [designerSelection, setDesignerSelection] = useState("")
    const [dateSelection, setDateSelection] = useState({ "startDate": moment(moment().subtract(13, 'days').toDate()).format("DD.MM.YYYY"), "endDate": moment(moment().toDate()).format("DD.MM.YYYY") })

    const [taskName, setTaskName] = useState("SalesReport unbekannter Task")
    const controller = new AbortController()
    const signal = controller.signal

    const [showAlertMessage, setShowAlert] = useState(false)

    const [billClearance, setBillClearance] = useState(false)
    const [billingCommandState, setBillingCommandState] = useState("Verkaufsabrechnung starten")
    const [billClearanceDate, setBillClearanceDate] = useState(singleDateSelect !== undefined && singleDateSelect !== "" ? singleDateSelect : moment(Date.now()).format("DD.MM.YYYY"))

    const openAlert = () => {
        setShowAlert(true)
    }
    const closeAlert = () => {
        setShowAlert(false)
    }

    useEffect(() => {
        console.log("Inventur Parameter werden geladen")
        setTaskName("Inventur Parameter werden geladen")
        FetchRegisterInventoryReport(setOptions, openAlert, signal, "SalesReport")

        return () => {
            controller.abort()
        }
    }, [])

    useEffect(() => {
        console.log("SalesReport useEffect")
        console.log(salesReport)
        setFilteredReports([...salesReport])
        setSortedReports([...salesReport])
    }, [salesReport])

    useEffect(() => {
        let filteredReport = filterReportBySearchInput([...sortedReports], searchInput)
        //filteredReport = filterReportByDateInput(filteredReport, dateSelect)
        //filteredReport = filterReportBySelectInput(filteredReport, statusSelect)
        setFilteredReports(filteredReport)
    }, [searchInput, dateSelect, statusSelect, sortedReports])

    const loadReport = (designerSysId) => {
        setTaskName("Die Auswertung wird geladen")
        let requestParam = {
            "Name": options[0].Name,
            "ReportId": options[0].ReportId.toString(),
            "DesignerSysId": designerSysId
        }
        FetchInventoryReport(setSalesReport, requestParam, openAlert, signal, "SalesReport")
    }

    const handleSetDesignerSelection = (designerSelect) => {
        let selectedDesigner = options[0].ReportParameters.find(y => y.Order === 1).Designers.find(x => x.Name.trim() === designerSelect.trim())
        if (selectedDesigner !== undefined) setDesignerSelection(selectedDesigner.DesignerSysId)
    }

    const loadDesignerSelection = () => {
        if (options !== null && options[0] !== undefined) {
            let designerNames = options[0].ReportParameters.find(y => y.Order === 1).Designers.map(x => x.Name).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
            let all = designerNames.splice(designerNames.findIndex(a => a.includes('Alle')), 1)
            designerNames.splice(0, 0, all[0])
            return (
                <FormControl className="filterForm reportSelect" defaultValue="" as="select" size="sm" onChange={(e) => handleSetDesignerSelection(e.target.value)}>
                    {designerNames.map(x => <option>{x}</option>)}
                </FormControl>
            )
        }
    }

    const handleReportLoad = () => {
        loadReport(designerSelection)
    }

    const setFilterbar = () => {
        setFilterable(!filterable)
    }

    const getCsvData = () => {
        let csvData;
        let InventoryName = "Inventur am " + (options.length > 0 ? options[0].ReportParameters.find(x => x.Order == 9).DateOfInventory : "")
        let PreinventoryName = "Vor der Inventur am " + (options.length > 0 ? options[0].ReportParameters.find(x => x.Order == 10).DateOfState : "");
        console.log("getCsvData", InventoryName, PreinventoryName)
            csvData = salesReport.map(x =>
            ({
                "Designer": x.Designer,
                "Artikelnr. FAEX": x.FAEXArticleNumber,
                "Artikelnr. Designer": x.ArticleNumberDesigner,
                "Artikelname": x.ArticleName,
                "Farbe": x.Colour,
                "Größe": x.Size,
                "VK Preis": x.PriceAtPointOfSelling,
                "Im Lager": x.AmountInStorage,
                [InventoryName]: x.AmountInInventory,
                [PreinventoryName]: x.AmountInPreinventory,
                "Differenz": x.Deviation
            }))

        return (csvData)
    }

    const getTotalAmount = (filteredReports, field) => {
        let total = 0
        let numbers = filteredReports.map(x => parseInt(x[field]))
        total = numbers.reduce((a, b) => a + b, 0)

        return total
    }

    const getTotalPrices = (filteredReports, field) => {
        let total = 0
        let numbers = filteredReports.map(x => parseFloat(x[field]))
        total = numbers.reduce((a, b) => a + b, 0)

        return total
    }

    const reload = () => {
        handleReportLoad()
    }

    const InventoryReportBoutique = () => {
        console.log("InventoryReportBoutique", filteredReports, options)
        return (
            <>
                <div className="tablet-transactions">
                    <Table className="table-sm table-striped-immediate ">
                        <thead className="sticky-table-header">
                            <th className="mainColumn">Designer
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Designer')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Artikelnr. FAEX
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'FAEXArticleNumber')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Artikelnr. Designer
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'ArticleNumberDesigner')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Artikelname
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'ArticleName')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Farbe
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Colour')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Größe
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Size')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Einzelpreis
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'DefaultSalePrice')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Im Lager
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'AmountInStorage')}>&#8593; &#8595;</a>
                            </th>
                            {options.length > 0 && options[0].ReportParameters.find(x => x.Order == 9) != null ?
                                <th className="mainColumn">Inventur am {options[0].ReportParameters.find(x => x.Order == 9).DateOfInventory}
                                    <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'AmountInInventory')}>&#8593; &#8595;</a>
                                </th> :
                                <th>
                                </th>}
                            {options.length > 0 && options[0].ReportParameters.find(x => x.Order == 10) != null ?
                                <th className="mainColumn">vor {options[0].ReportParameters.find(x => x.Order == 10).DateOfState}
                                    <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'AmountInPreinventory')}>&#8593; &#8595;</a>
                                </th> :
                                <th>
                                </th>}
                            {options.length > 0 && options[0].ReportParameters.find(x => x.Order == 11) != null ?
                                <th className="mainColumn">Differenz
                                    <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Deviation')}>&#8593; &#8595;</a>
                                </th> :
                                <th>
                                </th>}
                            {/*<th className="filterIndicator" onClick={setFilterbar}>&#8711; Filter</th>*/}
                            <th></th>
                        </thead>

                        <tbody>
                            {filteredReports.map(entry =>
                                <>
                                    <tr>
                                        <td>{entry.Designer}</td>
                                        <td>{entry.FAEXArticleNumber}</td>
                                        <td>{entry.ArticleNumberDesigner}</td>
                                        <td>{entry.ArticleName}</td>
                                        <td>{entry.Colour}</td>
                                        <td>{entry.Size}</td>
                                        <td className="numberColumn">{parseFloat(entry.DefaultSalePrice).toFixed(2).replace('.', ',') + "€"}</td>
                                        <td className="numberColumn">{entry.AmountInStorage}</td>
                                        {options.length > 0 && options[0].ReportParameters.find(x => x.Order == 9) != null ?
                                            <td className="numberColumn">{entry.AmountInInventory}</td> :
                                            <th>
                                            </th>}
                                        {options.length > 0 && options[0].ReportParameters.find(x => x.Order == 10) != null ?
                                            <td className="numberColumn">{entry.AmountInPreinventory}</td> :
                                            <th>
                                            </th>}
                                        {options.length > 0 && options[0].ReportParameters.find(x => x.Order == 11) != null ?
                                            <td className="numberColumn">{entry.Deviation}</td> :
                                            <th>
                                            </th>}
                                    </tr>
                                </>
                            )}

                            <tr className="stockReport-row">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Summe: </td>
                                <td className="numberColumn">{getTotalAmount(filteredReports, 'AmountInStorage')}</td>
                                {options.length > 0 && options[0].ReportParameters.find(x => x.Order == 9) != null ?
                                    <td className="numberColumn">{getTotalAmount(filteredReports, 'AmountInInventory')}</td> : <td></td>}
                                {options.length > 0 && options[0].ReportParameters.find(x => x.Order == 10) != null ?
                                    <td className="numberColumn">{getTotalAmount(filteredReports, 'AmountInPreinventory')}</td> : <td></td>}
                            </tr>
                        </tbody>
                    </Table>
                </div>

                <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
                <LoadingSpinner task={taskName} area={"SalesReport"} />
            </>
        )
    }

    return (
        <>
            <div className="report-menu searchBar">
                <div className="inline">
                    {loadDesignerSelection()}
                    &nbsp;&nbsp;
                    <Button variant="light" size="sm" className="form filter-button form-control sales-report-btn" onClick={() => handleReportLoad()}>Auswertung laden</Button>
                </div>
            </div>
            <br />

            <div className="inline">
                <FormControl className="globalSearch searchBar" as="input" defaultValue={searchInput} placeholder="Suche..." onChange={handleSearchInput}></FormControl>
                <ExportCSV className="searchBar" csvData={getCsvData()} fileName={"Inventur"} />
                {/*<div className="inline-forms">*/}
                {/*    <ExportCSV className="searchBar" disabled={disableExport} csvData={getCsvData()} fileName={"Verkäufe"} />*/}
                {/*</div>*/}
            </div>

            <InventoryReportBoutique />
        </>
    )
    
}

export default InventoryReport